import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlConfig } from '@shared/config/url.config';
import { CreerDossier } from '@shared/models/dispositif/creer-dossier';

@Injectable()
export class DispositifDataService {
  headers: HttpHeaders = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(private http: HttpClient) { }

  createOpp(infoDossier: CreerDossier): Observable<any> {
    return this.http.post<any>(`${UrlConfig.urlDossier}dossiers`, JSON.stringify(infoDossier), { headers: this.headers });
  }
}
